import axios from "./axios";
import { getConfig } from "../utils/sessionStorageUtils";

export const getCurrencies = async () => {
    try {
        const result = await axios.get(`/Currencies/GetCurrencies`, getConfig());
        return result.data;
    } catch (e) {
        console.error(e);
    }
};

export const getCurrencyRate = async (url: string) => {
    try {
        const result = await axios.get(`/Currencies/GetRate${url || ""}`, getConfig());
        return result.data;
    } catch (e) {
        console.error(e);
    }
};